"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'microphone.access.denied': 'Microphone access denied. Please allow microphone access to use voice features.',
};
